export default __webpack_public_path__ + "static/media/LMS.f5a878e3.png";